import React from 'react'
import { Box } from '@chatterbug/aaron'
import DateUtil from 'lib/date-util'
import { t } from 'src/lib/i18n-react'
import { getLanguageName } from 'lib/util'
import { getLocale } from 'src/config/globals'
import { CefrLevelCode, LanguageCode } from 'src/types'

import certificateBase from '../../../assets/images/certificates/certificate-base.svg'
import catbee from '../../../assets/images/common/logos/catbee-no-motion@2x.png'
import { getFlagIcon } from './assets/flags'
import { getSealIcon, getLevelNumber } from './assets/certificates'

export type Props = {
  cefrLevel: CefrLevelCode
  l2Code: LanguageCode
  licenseNumber: string
  fullName: string
  completedAt: string
}

/* Ported from app/views/modules/_certificate.html.erb */
const Certificate: React.FC<Props> = ({
  cefrLevel,
  l2Code,
  licenseNumber,
  fullName,
  completedAt,
}) => {
  const language = getLanguageName(l2Code)
  const levelCode = cefrLevel.toUpperCase()
  const levelNumber = t('level %{levelNumber}', {
    levelNumber: getLevelNumber(cefrLevel),
  })
  const sealIcon = getSealIcon(cefrLevel)

  return (
    <svg viewBox="0 0 500 283" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <image x="0" y="0" width="500" height="283" xlinkHref={certificateBase} />
      <image className="logo" x="235" y="34" width="30" xlinkHref={catbee} />
      <image
        x="439"
        y="38"
        width="18"
        height="18"
        xlinkHref={getFlagIcon(l2Code)}
      />
      <text
        fontFamily="SofiaProRegular, Sofia Pro"
        fontSize="8"
        fill="#303030"
        textAnchor="middle"
      >
        <tspan x="448" y="69">
          {levelNumber}
        </tspan>
      </text>

      {sealIcon && (
        <image x="218" y="189" width="65" height="65" xlinkHref={sealIcon} />
      )}

      <text
        fontFamily="SofiaProMedium, Sofia Pro"
        fontSize="11"
        fontWeight="400"
        fill="#303030"
      >
        <tspan x="41.025641" y="148.794872">
          {fullName}
        </tspan>
      </text>
      <text
        fontFamily="SofiaProRegular, Sofia Pro"
        fontSize="9"
        fontWeight="normal"
        fill="#BBBBBB"
      >
        <Box
          as="tspan"
          x="41"
          y="165"
          dangerouslySetInnerHTML={{
            __html: t(
              'Completed the Chatterbug %{languageAndLevel} course on %{date}',
              {
                languageAndLevel: `<tspan fill="#303030">${language} ${levelCode} / ${levelNumber}</tspan>`,
                date: `<tspan fill="#303030">${DateUtil.format(
                  DateUtil.dateFromISOString(completedAt, getLocale()),
                  'cb_MMMDYYYY'
                )}</tspan>`,
              }
            ),
          }}
        ></Box>
      </text>

      <text
        fontFamily="SofiaProMedium, Sofia Pro"
        fontSize="11"
        fontWeight="400"
        fill="#303030"
      >
        <tspan x="41.025641" y="91.7948718">
          {t('CERTIFICATE of ACHIEVEMENT')}
        </tspan>
      </text>
      <foreignObject x="41" y="98" width="380" height="25">
        <Box css="font-family: SofiaProRegular, Sofia Pro; font-size: 9px; font-weight: normal; color: #BBBBBB; line-height: 1.4;">
          {t(
            'This certifies that the user has completed all %{language} level coursework and been verified by our tutors in speaking and listening skills in the target language.',
            { language }
          )}
        </Box>
      </foreignObject>
      <text
        fontFamily="SofiaProRegular, Sofia Pro"
        fontSize="8"
        fontWeight="normal"
        fill="#BBBBBB"
      ></text>

      <text
        fontFamily="Consolas"
        fontSize="8"
        fontWeight="normal"
        fill="#BBBBBB"
        textAnchor="end"
      >
        <tspan x="460" y="253">
          {t('License #%{licenseNumber}', { licenseNumber })}
        </tspan>
      </text>
    </svg>
  )
}

export default Certificate
